import * as angular from "angular";
import userRequests from "../../user-requests/user-requests";
import template from "./user-modal-requests-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";

export interface UserModalRequestsTabController {
	user?: unknown;
	openRequests?: unknown[];
}

// eslint-disable-next-line no-redeclare
export class UserModalRequestsTabController {
	public readonly tab: ModalTabItem = {
		name: "Requests",
		code: "REQUESTS"
	};
}

export default angular
	.module("vesl.components.user-modal.tabs.requests", [userRequests])
	.component("userModalRequestsTab", {
		controller: UserModalRequestsTabController,
		template,
		bindings: {
			user: "<",
			openRequests: "="
		}
	})
	.name;
